import { render, staticRenderFns } from "./_head.vue?vue&type=template&id=34f5bff7"
import script from "./_head.vue?vue&type=script&lang=js"
export * from "./_head.vue?vue&type=script&lang=js"
import style0 from "./_head.vue?vue&type=style&index=0&id=34f5bff7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports